export const USERS_TODO = [
  'GET /admin/users o GET /tenant-admins para listar usuarios internos de la clinica',
  'POST /admin/users para crear admins, veterinarios, recepcionistas, tienda y visualizadores',
  'PATCH /admin/users/:id para editar email, rol y permisos',
  'PATCH /admin/users/:id/status para activar o desactivar acceso',
  'POST /admin/users/:id/password-reset para forzar recuperacion o cambio de clave'
];

export const listInternalUsers = async () => {
  // TODO backend: no existe endpoint admin para tenant_admins/usuarios internos.
  return [];
};
